export * from './app-suppliersidebar.component';



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/components/app-suppliersidebar/index.ts